import { type PaletteOptions, type SimplePaletteColorOptions } from "@mui/material";
import { type ThemeOptions } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";
import { typographyMixin } from "@pmag/ui-components";
import { isButtonVariant } from "@pmag/ui-components/lib/src/components/buttons/button/Button.utils";
import { getCommonButtonStyles } from "@pmag/ui-components/lib/src/components/buttons/commonButtonStyles";
import { paletteOptions } from "@pmag/ui-components/lib/src/theme/pmagThemeOptions";

const primaryColors: SimplePaletteColorOptions = {
    contrastText: "#FFFFFF",
    dark: "#7C5D19",
    light: "#C19D50",
    main: "#B28525",
};

const mergedPaletteOptions: PaletteOptions = deepmerge<PaletteOptions>(paletteOptions, { primary: primaryColors });

export const mvAgustaThemeOptions: ThemeOptions = {
    palette: mergedPaletteOptions,
    shape: {
        borderRadius: 4,
    },
    typography: {
        fontFamily: "'Sharp Grotesk', sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState, theme }) => {
                    if (isButtonVariant(ownerState.variant)) {
                        return {
                            ...typographyMixin(theme, "body-short-01"),
                            ...getCommonButtonStyles(theme, ownerState.variant),
                            borderRadius: 2,
                            textTransform: "uppercase",
                        };
                    }

                    return {};
                },
            },
        },
    },
};
